
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { FC } from 'react';
import { ContactForm } from '@components/forms/ContactForm';
import useTranslation from 'next-translate/useTranslation';
import SEO from '@components/SEO';
import { Content } from '@components/Layout';
const Contact: FC = () => {
    const { t } = useTranslation('contact');
    return (<Content>
      <SEO title={t('title')}/>
      <h1>{t('title')}</h1>

      <ContactForm />
    </Content>);
};
export default Contact;

    async function __Next_Translate__getStaticProps__1898874f5e5__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/contact',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1898874f5e5__ as getStaticProps }
  